// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--CKDZq","searchRoot":"searchRoot--W8j4v","searchBar":"searchBar--arMQw","searchIconWrapper":"searchIconWrapper--AGVTr"};